import { redirect } from '@tanstack/react-router'

import { validateSessionHandler } from '@/features/Auth/server.ts'
import {
    getDefaultRouteForPermissions,
    getPermissionForRoute,
    hasPermission,
} from '@/lib/Permissions/permissions.ts'

export async function requireAuthenticatedRoute(redirectTo?: string) {
    const session = await validateSessionHandler()

    if (!session.user) {
        throw redirect({ to: '/login' })
    }

    if (session.maintenance.isActive && !session.canBypassMaintenance) {
        throw redirect({
            to: '/maintenance',
            search: redirectTo ? { redirect: redirectTo } : undefined,
        })
    }

    return session
}

export async function requireConfiguredPermissionRoute(pathname: string) {
    const session = await requireAuthenticatedRoute(pathname)

    requireConfiguredPermissionForSession(pathname, session.permissions)

    return session
}

export function requireConfiguredPermissionForSession(
    pathname: string,
    permissions: Array<string> = [],
) {
    const permission = getPermissionForRoute(pathname)

    if (permission && !hasPermission(permissions, permission)) {
        throw redirect({
            to: getDefaultRouteForPermissions(permissions),
        })
    }
}
